// extracted by mini-css-extract-plugin
export var black = "_3w-6";
export var brand = "_3w-1";
export var ddefault = "_3w-0";
export var error = "_3w-3";
export var gray = "_3w-2";
export var highContrast = "_3w-8";
export var outline = "_3w-7";
export var success = "_3w-5";
export var warning = "_3w-4";